import { render, staticRenderFns } from "./TranslationsTable.vue?vue&type=template&id=97ae761e&scoped=true&"
import script from "./TranslationsTable.vue?vue&type=script&lang=ts&"
export * from "./TranslationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsTable.vue?vue&type=style&index=0&id=97ae761e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae761e",
  null
  
)

export default component.exports